import { AlertProps } from "@jugl-web/ui-kit";
import { createContext } from "react";

export interface UIComponentsContextType {
  showAlert: (
    options: Omit<AlertProps, "isOpen" | "onRequestClose"> & {
      onClosed?: () => void;
    }
  ) => void;
}

export const UIComponentsContext = createContext<
  UIComponentsContextType | undefined
>(undefined);
